<template>
  <div class="body" :style="{ background: 'url(' + PayImgUrl + ')' }">
    <div class="btn" @click="toShowTitl()"></div>

    <!--显示活动弹窗-->
    <div class="v-dialog" v-if="isDialogShow">
      <div class="v-dialog-bg"></div>
      <div class="v-dialog-content" :style="{ 'height': showTwoFlg ? '340px' : '210px' }">
        <div class="h2-name">限时活动特惠套餐</div>
        <van-count-down :time="time" format="HH:mm:ss">
          <template #default="timeData">
            <span class="block">{{ timeData.hours < 10 ? '0' + timeData.hours : timeData.hours }}</span>
                <span class="colon">:</span>
                <span class="block">{{ timeData.minutes < 10 ? '0' + timeData.minutes : timeData.minutes }}</span>
                    <span class="colon">:</span>
                    <span class="block">{{ timeData.seconds < 10 ? '0' + timeData.seconds : timeData.seconds }}</span>
          </template>
        </van-count-down>
        <van-notice-bar left-icon="volume-o" :scrollable="false" style="margin-top: 10px;">
          <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
            <van-swipe-item>张** 159****8668 看视频畅通无阻 非常溜！</van-swipe-item>
            <van-swipe-item>李* 159****1368 确实能省钱，推荐，推荐！</van-swipe-item>
            <van-swipe-item>赵** 135****9772 优惠力度很大很实惠</van-swipe-item>
            <van-swipe-item>曾** 198****663 朋友推荐的，用着确实不错</van-swipe-item>
            <van-swipe-item>张** 183****1814 流量太多了 根本用不完！</van-swipe-item>
            <van-swipe-item>钱** 151****1396 现在活动力度挺大的，我在领一张</van-swipe-item>
            <van-swipe-item>孙** 159****8668 太适合我们这种大流量用户了吧</van-swipe-item>

          </van-swipe>
        </van-notice-bar>
        <div class="j-btn" @click="sureToRecharge()">
          <div class="czhi">充<span class="price">{{ payPrice }}</span>元得<span class="price1">{{ salePrice }}</span>元
          </div>
          <div class="sumbit_btn"></div>
        </div>
        <div class="v-dialog-close" :style="{ 'bottom': showTwoFlg ? '-350px' : '-350px' }">
          <img src="@/assets/dzp/dialog_close.png" alt="" @click="isDialogShow = false" />
        </div>
      </div>
    </div>



    <div class="customer" @click="cust">
      <img src="@/assets/232131.png" alt="" />
      <div class="zx">在 线 客 服</div>
    </div>

    <div v-html="payUrl"></div>
    <div class="shareit" v-if="is_WeChat">
      <img class="arrow" src="@/assets/img/arrowhead.png" />
      <div class="follow">
        支付宝支付请右上角点击 在游览器打开 进行支付,<br />支付成功后
        请重新扫码登录进行激活操作<br />
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      time: 0,
      showTwoFlg: false,
      toBuyPkgId: localStorage.getItem("toBuyPkgId"),
      PayImgUrl: localStorage.getItem("PayImgUrl"), //页面地址
      is_WeChat: false,
      payUrl: "",
      payPrice: localStorage.getItem("payPrice"),
      salePrice: localStorage.getItem("salePrice"),
      isBindPhones: this.$store.state.isBindPhone,
      newHome: this.$store.state.newHome,
      newHomes: localStorage.getItem("newHome"),
      input: this.$store.state.recordLoginText,
      isDialogShow: false,
      //设置密码
      password: "",
      confirmPassword: "",
      alreadySetUp: false,
      showPasswordPanel: false,
      passwordKeyboard: false,
      confirmPasswordKeyboard: false,
      passwordPanelTop: 50,

      //当前余额套餐
      currentItem: 0,
      price: 0,
      giftBalance: 0,

      //自定义金额
      popup: false,

      //自定义键盘
      showKeyboard: false,
      definedPrice: "",

      type: "",
      indexActive: "",
    };
  },

  created() {
    this.time = 2 * 60 * 60 * 1000;
    this.is_WeChat = false;
    if (this.$route.query.row) {
      this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row));
      this.$nextTick(() => {
        document.forms[0].submit();
      });
    }
  },

  methods: {
    toShowTitl() {
      this.sureToRecharge();
    },
    cust() {
      window.location.href =
        "http://kefu.szxxtx.com/s/135302p4tv";
    },

    /***   修改密码     ***/
    passwordOnfocus() {
      this.passwordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    passwordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1);
    },

    passwordOnInput(key) {
      this.password = (this.password + key).slice(0, 6);
    },

    confirmPasswordOnfocus() {
      this.passwordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(
        0,
        this.confirmPassword.length - 1
      );
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },

    cancelChangePassword() {
      this.password = "";
      this.confirmPassword = "";
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },

    checkPassword() {
      if (this.password.length < 6) {
        Dialog.alert({ message: "请设置六位支付密码" });
        return false;
      }

      if (this.password != this.confirmPassword) {
        Dialog.alert({ message: "两次输入的新密码不一致" });
        return false;
      }
      return true;
    },

    /***   修改密码  end   ***/
    sumbit() {
      this.showPasswordPanel = true;
    },
    onBridgeReady(param) {
      let _this = this;
      WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          setTimeout(function () {
            _this.$router
              .push({
                path: "/newUser/home",
                query: {
                  iccid: _this.$store.state.iccid,
                },
              })
              .catch(() => { });
          }, 500);
        }
      });
    },
    async sureToRecharge() {
      var params = {
        ali: 'pkg',
        iccid: localStorage.getItem("iccid"),
        soldPackageId: this.toBuyPkgId, //固定值
        isNextMonth: 0, //固定值
        isAdmin: 1, //固定值
        payType: 20, // 固定微信支付
      };
      var postUrl = "order/pkgOrder/add";
      await wxRequest("sim/pay/type", params, "post").then((res) => {
        if (res.data.code == 492) {
          postUrl = "order/ali/pkgOrder/add/yy";
          params.payType = 92;
        }
      });
      let formData = new FormData();
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });

      await wxRequest(postUrl, formData, "post").then((res) => {
        if (res.data.code == 200) {
          if (params.payType == 50) {
            //乐刷de
            window.location.href = res.data.data.jspay_url;
          } else if (params.payType == 92 || params.payType == 93|| params.payType == 98) {
            //云游
            window.location.href = res.data.data;
          } else if (params.payType == 20) {
            //微信第三方
            var param = res.data.data.param;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (params.payType == 90) {
            //微信第三方
            var param = res.data.data;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (params.payType == 60) {
            //汇付天下
            let datas = JSON.parse(res.data.data);
            if (datas.status === "succeeded") {
              let payment = datas;
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: "提示", message: res.result_message });
              });
            }
          } else if (params.payType == 80) {
            window.location.href = res.data.data;
          }
        } else {
          Dialog.alert({ message: res.data.message });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.body {
  .customer {
    position: fixed;
    right: 6px;
    top: 40%;
    width: 40px;
    height: 120px;
    text-align: center;
    color: #ffffff;
    background: #75b0ff;
    border-radius: 20px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    writing-mode: vertical-rl;
    font-family: HarmonyOS_Sans_SC_Medium;

    img {
      width: 22px;
      height: 22px;
      margin-bottom: 6px;
    }
  }

  // background: url("../../assets/newUser/img/simOpen108.png") no-repeat center; //PayImgUrl
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 100% 100% !important;
  width: 100%;
  height: 100vh;
  position: relative;

  .btn {
    width: 325px;
    position: fixed;
    bottom: 20px;
    left: 0px;
    right: 0px;
    margin: auto;
    height: 64px;
    background: url("../../assets/dzp/6fdec6ce1.png") no-repeat center;
    background-size: 100% 100%;
  }

  .v-dialog {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 9;

    .v-dialog-bg {
      position: fixed;
      background: rgba(0, 0, 0, 0.7);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 100%;
    }

    .v-dialog-close {
      width: 22px;
      height: 22px;
      // margin:0 auto;
      // margin-top:20px;
      position: fixed;
      top: 0;
      bottom: -450px;
      left: 0;
      right: 0;
      margin: auto;

      img {
        height: 100%;
        cursor: pointer;
      }
    }

    .v-dialog-content {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 80%;
      height: 340px;
      border-radius: 10px;
      text-align: center;
      padding: 20px;
      background: #fff;

      .h2-name {
        color: #ff4c22;
        font-size: 18px;
        font-weight: bold;
        font-family: SourceHanSansSC-Bold;
        margin-bottom: 14px;
      }

      .colon {
        display: inline-block;
        margin: 0 4px;
        color: #fff;
      }

      .block {
        display: inline-block;
        width: 40px;
        height: 28px;
        color: #fff;
        font-size: 20px;
        letter-spacing: 12px;
        padding-left: 6px;
        text-align: center;
        line-height: 28px;
        text-align: center;
        background: url('../../assets/djs-bg.png') no-repeat center;
        background-size: 100% 100%;
      }

      .j-btn {
        display: flex;
        height: 94px;
        width: 100%;
        margin: 0 auto;
        background: url('../../assets/cz_bg.png') no-repeat center;
        background-size: 100% 100%;
        margin-top: 6px;
      }

      .czhi {
        color: #8d5d2a;
        font-size: 12px;
        margin-top: 38px;
        margin-left: 20px;

        .price {
          font-size: 16px;
          padding: 0 5px;
          color: #ff4c22;
          font-weight: bold;
        }

        .price1 {
          font-size: 34px;
          font-weight: bold;
          color: #ff4c22;
        }
      }

      .sumbit_btn {
        width: 175px;
        height: 90px;
        position: absolute;
        display: flex;
        margin: auto;
        right: 0px;
        background: url("../../assets/active-btn.png") no-repeat center 56%;
        background-size: 50% 35%;
      }
    }

    .notice-swipe {
      height: 40px;
      line-height: 40px;
    }

    .follow {
      margin-right: 6px;
      margin-left: 30px;
      width: 90%;
      // height: 100rpx;
      line-height: 30px;
      // text-align: left;
      text-decoration: none;
      font-size: 18px;
      color: white;
      float: left;
      margin-top: 180px;
    }
  }

}

.changePasswordPanel-cardSetUp {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }
}

.shareit {
  -webkit-user-select: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 999;
}

.shareit img {
  max-width: 100%;
}

.arrow {
  width: 100px;
  height: 150px;
  position: absolute;
  right: 5%;
  top: 1%;
}

.follow {
  margin-right: 6px;
  margin-left: 30px;
  width: 90%;
  // height: 100rpx;
  line-height: 30px;
  // text-align: left;
  text-decoration: none;
  font-size: 18px;
  color: white;
  float: left;
  margin-top: 180px;
}
</style>
